import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=53363781&scoped=true"
import script from "./FamilyList.ts?vue&type=script&lang=ts&external"
export * from "./FamilyList.ts?vue&type=script&lang=ts&external"
import style0 from "./FamilyList.vue?vue&type=style&index=0&id=53363781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53363781",
  null
  
)

export default component.exports